<template>
    <form class="item-editor-form">
        <fg-input v-model="item.id" :label="$t('device_view.id')" disabled></fg-input>
        <fg-input v-model="item.name" :label="$t('device_view.name')"></fg-input>
        <fg-input v-model="item.description" :label="$t('device_view.description')"></fg-input>
        <label for="devicetype">{{ $t('device_view.type') }}:</label>
        <deviceTypeSelect v-model="item.type" id="devicetype"/>
        <label for="infopoint-id">{{ $t('device_view.infopoint') }}:</label>
        <infopointSelect v-model="item.infopoint" id="infopoint-id"/>

        <label for="latitude">{{ $t('device_view.coordinates') }} <br> {{ $t('device_view.latitude') }}:</label>
        <floatInput v-model="item.location.latitude" id="latitude"></floatInput>
        <label for="longitude">{{ $t('device_view.longitude') }}:</label>
        <floatInput v-model="item.location.longitude" id="longitude"></floatInput>

        <FormButtons
            @submit="submit"
            :reset="false" 
            :remove="action == 'edit'" 
            @remove="remove"/>

        <b-modal id="testmodal" static @ok="removeOK" :title='delModalTitle'>
            {{ $t("device_view.delete_confirm.msg") }}</b-modal>
    
        <b-toaster name="myToaster" class="b-toaster-top-right"></b-toaster>
    
    </form>
</template>

<script>
import infopoint from '@/store/displays/infopoint'
import deviceTypeSelect from '@/components/Devices/Device/DeviceTypeSelect'
import infopointSelect from '@/components/Display/InfopointSelect'
import floatInput from '@/components/Generic/FloatInput'

export default {
    components: { 
        infopointSelect, deviceTypeSelect, floatInput
    },
    props: {
        item: { 
            default: function () {
                return {
                    "deviceId": null,
                    "name": null,
                    "description": null,
                    "type": null, 
                    "infopoint" : null,
                    "location" : {
                        "latitude" :null, 
                        "longitude" : null
                    }
                } 
            }        
        },        
        action: { default: "new" }
    },
    data() {
        return  {
            defaultFormData: {
                "deviceId": null,
                "name": null,
                "description": null,
                "type": null, 
                "infopoint" : null,
                "location" : {
                    "latitude" :null  , 
                    "longitude" : null
                } 
            },
            modal: false
        }
    },
    computed: {
        delModalTitle() {
            return this.$t("device_view.delete_confirm.title")
        }
    },
    methods: {
        reset(event){
            event.preventDefault();
            this.item = this.defaultFormData;
        },
        remove() {
            this.$bvModal.show('testmodal')
        },
        removeOK: function() {
            this.$store.dispatch('device/deleteDevice' , this.item.deviceId ).then( () => {
                this.$bvToast.toast(this.$t("notify.deleted"), {
                    title: this.$t('notify.notice'),
                    variant: 'success',
                    autoHideDelay: 2000,
                    toaster: 'myToaster'
                } )
                }, () => {
                    this.$bvToast.toast(this.$t("device_view.error_delete"), {
                        title: this.$t('notify.notice'),
                        variant: 'danger',
                        autoHideDelay: 2000,
                        toaster: 'myToaster'
                    } )
                } )
                .catch()
                .then(() => {
                    this.item = this.defaultFormData;                    
                })
        },
        submit: function(event) {
            if(event) event.preventDefault();
            var id = this.item.infopoint; 
            if( id == null )
                id ="";

            if( this.item.attributes == null ) {
                this.item.attributes = [];
            }
            var found = false;
            
            for( var a of this.item.attributes ) {       
                if( a.name=="INFOPOINT_ID" ) {
                    a.value = id.toString();
                    found = true;
                    break;
                }
            }
            if( !found ) {
                this.item.attributes.push( { name:"INFOPOINT_ID" , value: id.toString() })
            }
            this.$bvToast.toast(this.$t("notify.saving"), {
                        title: this.$t('notify.notice'),
                        variant: 'success',
                        autoHideDelay: 2000,
                        toaster: 'myToaster'
                    } )

            this.$store.dispatch('device/updateDevice' , this.item ).then( () => {
                 this.$bvToast.toast(this.$t("notify.saved"), {
                        title: this.$t('notify.notice'),
                        variant: 'success',
                        autoHideDelay: 2000,
                        toaster: 'myToaster'
                    } )
            }, () => {
                 this.$bvToast.toast(this.$t("device_view.error_save"), {
                        title: this.$t('notify.notice'),
                        variant: 'danger',
                        autoHideDelay: 2000,
                        toaster: 'myToaster'
                    } )
            } )
        },
        onReset: function(event) {
            event.preventDefault(); 
            this.item = this.defaultFormData;
        }
    },
    created() {
        if( !this.$store.state.infopoint) {
             this.$store.registerModule("infopoint" , infopoint);
        }
    },
    mounted() {
        this.$store.dispatch('infopoint/getInfopointList');
    }

}
</script>

